import axiosInstance from '../../helpers/axiosConfig';
import config from '../../config';

export const avisosGet = async () => {
    console.log("Getting avisos")
   const baseUrl = config.REACT_APP_BASE_URL

    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access-token')}`
      };

    try {
        const response = await axiosInstance.get(`${baseUrl}Menu/ExtraUrls`, { headers })
  
        // console.log('getExtraUrl: ', response)
        return response.data
      } catch (error) {
         console.error('Avisos Service - catch Error:', error)
        throw error
      }
}